module.exports = __webpack_public_path__ + "static/media/3_Phones.03765dfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/LandingPage/Components/Footer/img/3_Phones.png
// module id = 68
// module chunks = 0